import { Table } from '@tanstack/react-table';
import {
  TableRoofChipList,
  TableRoofFilter
} from '../../compound/tables/presentation/table/roofs/shared';
import { TableFilter } from './filter';
import { DataTableResults } from './results';
import { DataTableSearch } from './search';

export const TableToolBar = <T,>({
  table,
  canDeselect = true
}: {
  table: Table<T>;
  canDeselect?: boolean;
}) => {
  return (
    <div className="flex items-center min-h-12 justify-between">
      <DataTableResults table={table} canDeselect={canDeselect} />
      <TableRoofChipList
        chips={table.getState().columnFilters.map((filter) => {
          const column = table.getColumn(filter.id);
          const filterOptions = column?.columnDef.meta?.filterOptions;

          let label;
          if (
            Array.isArray(filter.value) &&
            (filter.id === 'available_benefit_budget_next_month' || filter.id === 'entry_date')
          ) {
            const [min, max] = filter.value;
            if (min && max) {
              label = `${min} - ${max}`;
            } else if (min) {
              label = `≥ ${min}`;
            } else if (max) {
              label = `≤ ${max}`;
            } else {
              label = '';
            }
          } else {
            label = String(filter.value);
          }

          if (filterOptions) {
            const option = filterOptions.find((opt) => String(opt.value) === String(filter.value));
            if (option) {
              label = option.text;
            }
          }

          return {
            label: label,
            value: filter.id,
            onDelete: () => {
              table.getColumn(filter.id)?.setFilterValue(undefined);
              table.resetRowSelection();
            }
          };
        })}
        justify="flex-start"
        sx={{
          width: '500px'
        }}
      />
      <DataTableSearch table={table} />
      <TableRoofFilter renderFilter={() => <TableFilter table={table} />} />
    </div>
  );
};
